module.exports = __webpack_public_path__ + "img/76292.8151f3e8.svg";